function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.185 31.059V15.528h4.532l.6-5.353h-5.132l.008-2.678c0-1.396.14-2.144 2.26-2.144h2.832V0h-4.532c-5.444 0-7.36 2.596-7.36 6.963v3.213H0v5.352h3.393v15.53h6.792z",
  fillRule: "evenodd"
});

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 32",
    fill: "currentColor"
  }, props), _ref);
}

export default SvgFacebook;